export default "__VITE_ASSET__Fahs4Ey7__"